import React from 'react'
import classnames from 'classnames'
import { Button, TextField, CircularProgress } from '@mui/material'

const AccountForm = props => {
    const {
        values: { firstName, lastName, displayName, email, phone },
        errors,
        touched,
        handleSubmit,
        handleChange,
        handleBlur,
        isValid,
        isSubmitting,
        formClasses,
    } = props

    return (
        <form className={formClasses.form} onSubmit={handleSubmit}>
            <TextField
                className={formClasses.textField}
                id="firstName"
                name="firstName"
                helperText={touched.firstName ? errors.firstName : ''}
                error={touched.firstName && Boolean(errors.firstName)}
                label="First Name"
                value={firstName || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                margin="normal"
            />
            <TextField
                className={formClasses.textField}
                id="lastName"
                name="lastName"
                helperText={touched.lastName ? errors.lastName : ''}
                error={touched.lastName && Boolean(errors.lastName)}
                label="Last Name"
                value={lastName || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                margin="normal"
            />
            <TextField
                className={classnames(formClasses.textField, formClasses.extraMargin)}
                id="displayName"
                name="displayName"
                helperText={touched.displayName ? errors.displayName : ''}
                error={touched.displayName && Boolean(errors.displayName)}
                label="Display Name"
                value={displayName || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                margin="normal"
            />
            <TextField
                className={formClasses.textField}
                id="email"
                name="email"
                helperText={touched.email ? errors.email : ''}
                error={touched.email && Boolean(errors.email)}
                label="Email Address"
                value={email || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                margin="normal"
            />
            <TextField
                className={formClasses.textField}
                id="phone"
                name="phone"
                helperText={touched.phone ? errors.phone : ''}
                error={touched.phone && Boolean(errors.phone)}
                label="Phone Number"
                value={phone || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                margin="normal"
            />
            <div className={formClasses.buttonWrapper}>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={formClasses.submit}
                    disabled={!isValid || isSubmitting}
                >
                    {isSubmitting ? <CircularProgress size={24} className={formClasses.buttonProgress} /> : 'Save'}
                </Button>
            </div>
        </form>
    )
}

export default AccountForm
